import {screeningAction } from 'src/redux/actions/constant';

const {
    RESET_EDIT_SCREENING,
    EDIT_SCREENING_SUCCESS,
    EDIT_SCREENING_FAILURE,
} = screeningAction;

const intitialstate: object = {
  isScreeningEdited: false,
  response: null,
};

export const editScreeningReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case EDIT_SCREENING_SUCCESS: {
      return {
        ...state,
        isScreeningEdited: true,
        response: action.payload,
      };
    }

    case EDIT_SCREENING_FAILURE:
      return {
        ...state,
        isScreeningEdited: false,
        response: action.payload,
      };

    case RESET_EDIT_SCREENING:      
      return intitialstate;

    default:
      return state;
  }
};
